import { WebPlugin } from '@capacitor/core';
export class JustWeiWechatWeb extends WebPlugin {
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
    registerWx() {
        throw this.unimplemented('Not implemented on web.');
    }
    authLogin() {
        throw this.unimplemented('Not implemented on web.');
    }
    pay(payParams) {
        // 使用 PayParams 类型替代内联定义
        console.log(payParams);
        //for web send request to api to get qr code then scan
        throw this.unimplemented('Not implemented on web.');
        // return new Promise(() => ({ payResult: '0' }));
    }
    async share(shareParams) {
        console.log('Share Params:', shareParams);
        throw this.unimplemented('Not implemented on web.');
        // // 实际需集成微信JS-SDK，这里为示例
        // if (typeof window.wx === 'undefined') {
        //   throw this.unimplemented('微信JS-SDK未加载');
        // }
        // return new Promise((resolve, reject) => {
        //   window.wx.ready(() => {
        //     const shareConfig = {
        //       title: shareParams.title || '',
        //       desc: shareParams.description || '',
        //       link: shareParams.url || '',
        //       imgUrl: shareParams.imagePath || '',
        //       success: () => resolve({ result: 'success' }),
        //       cancel: () => resolve({ result: 'cancel' }),
        //       fail: (err: any) => resolve({ result: 'fail' })
        //     };
        //     // 根据场景设置分享按钮（需配合微信JS-SDK配置）
        //     if (shareParams.scene === 'timeline') {
        //       window.wx.onMenuShareTimeline(shareConfig);
        //     } else {
        //       window.wx.onMenuShareAppMessage(shareConfig);
        //     }
        //   });
        // });
    }
}
//# sourceMappingURL=web.js.map